import { Grid } from "@mui/material";
import { useTranslation } from "next-i18next";
import { useAllProjects } from "../../../data/projects/useAllProjects";

import NWONBackgroundLetter from "../../01-atoms/NWONBackgroundLetter/NWONBackgroundLetter";
import {
  LetterName,
  LetterPosition,
} from "../../01-atoms/NWONBackgroundLetter/NWONBackgroundLetterInterfaces";
import { NWONSectionTitle } from "../../01-atoms/NWONSectionTitle/NWONSectionTitle";
import NWONProjectCard from "../../02-molecules/NWONProjectCard/NWONProjectCard";
import NWONSection from "../NWONSection/NWONSection";
import { useNWONProjectsOverviewStyles } from "./NWONProjectsOverviewStyles";

const NWONProjectsOverview = (): JSX.Element => {
  const { classes } = useNWONProjectsOverviewStyles();
  const { t } = useTranslation<"pages">("pages");
  const projects = useAllProjects();

  return (
    <NWONSection>
      <NWONBackgroundLetter
        letter={LetterName.O}
        position={LetterPosition.Right}
        className={classes.letterN}
      />

      <NWONBackgroundLetter
        letter={LetterName.N}
        position={LetterPosition.Left}
        className={classes.letterO}
      />

      <NWONSectionTitle title={t("projects.projectsOverview.title")} />

      <Grid container={true} spacing={1} className={classes.projectsWrapper}>
        {projects.map((project, index) => {
          return (
            <Grid
              // Disable ESLint for the next line to define the index as the key of the Grid
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              item={true}
              sm={12}
              md={6}
              lg={4}
              className={classes.cardWrapper}
            >
              <NWONProjectCard project={project} />
            </Grid>
          );
        })}
      </Grid>
    </NWONSection>
  );
};

export default NWONProjectsOverview;
